module.exports = __webpack_public_path__ + "static/changes-5df0a5ed4f9aa86850bb9dbc02147316.jpg";